import type { ApolloError } from "@apollo/client";
import { env } from "@/env";
import { captureException as captureSentryException } from "@sentry/browser";

export const captureException = (err: unknown) => {
  if (env.VITE_NODE_ENV === "production") {
    captureSentryException(err);
  } else {
    console.error((err as ApolloError).message);
  }
};
